//Date Prototype functions
Date.daysBetween = function (date1, date2) {
	let one_day = 1000 * 60 * 60 * 24,
		date1_ms = date1.getTime(),
		date2_ms = date2.getTime(),
		difference_ms = date2_ms - date1_ms;
	return Math.round(difference_ms / one_day);
};

Date.prototype.addDays = function(days) {
	let date = new Date(this.valueOf());
	date.setDate(date.getDate() + days);
	return date;
};